import { Fragment } from 'react';
import { PreviewPanelsProvider as PreviewPanelProviderBase } from '@atlassian/preview-panels-api';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';

const PreviewPanelProvider = componentWithFG(
	'jira-glance-panel',
	PreviewPanelProviderBase,
	Fragment,
);

export default PreviewPanelProvider;
